// @flow

import type { Dispatch } from 'redux';
import {
  SUCCESS_STORING_CONFIGURATION,
  REQUEST_STORING_CONFIGURATION,
  FAILURE_STORING_CONFIGURATION,
  RETRY_STORING_CONFIGURATION,
  RESET_STORING_CONFIGURATION,
} from './constants';

import type {
  SuccessStoringConfiguration,
  RequestStoringConfiguration,
  FailureStoringConfiguration,
  RetryStoringConfiguration,
  ResetStoringConfiguration,
} from './types';

import { getConfiguration } from '../actives/selectors/configuration';
import { fetchData, isMultiLanguage } from '../../../helpers';
import { getActiveLanguage } from '../../activeLanguage/selectors';

declare var __BROWSER__ : string;

export const successConfiguration = (response: Object): SuccessStoringConfiguration => ({
  type: SUCCESS_STORING_CONFIGURATION,
  response,
});

export const requestConfiguration = (): RequestStoringConfiguration => ({
  type: REQUEST_STORING_CONFIGURATION,
});

export const failConfiguration = (error: Object): FailureStoringConfiguration => ({
  type: FAILURE_STORING_CONFIGURATION,
  error,
});

export const retryForm = (): RetryStoringConfiguration => ({
  type: RETRY_STORING_CONFIGURATION,
});

export const resetConfiguration = (): ResetStoringConfiguration => ({
  type: RESET_STORING_CONFIGURATION,
});

export type ProcessConfigurationOptions = {|
  endpoint?: string,
  personalData: Object,
  meta?: Object,
|};

type OrderResponse = {
  contractId: number,
  loginHash: string,
  order_number: number,
  success: boolean,
};

export const processConfiguration = ({
  endpoint = '/form/order',
  personalData,
  meta = {},
}: ProcessConfigurationOptions): Function => (
  async (dispatch: Dispatch<*>, getState: Function): Promise<OrderResponse> => {
    const state = getState();
    const language = isMultiLanguage() ? getActiveLanguage(state) : null;

    let personal = {
      ...personalData,
    };

    if (personalData.date_of_birth) {
      const { day, month, year } = personalData.date_of_birth;

      personal = {
        ...personal,
        date_of_birth: `${day}-${month}-${year}`,
      };
    }

    if (personalData.address) {
      const {
        city,
        house_number,
        postal_code,
        street,
        house_number_suffix,
      } = personalData.address;
      delete personal.address;

      personal.city = city;
      personal.house_number = house_number;
      personal.postal_code = postal_code;
      personal.street = street;
      personal.house_number_suffix = house_number_suffix;
    }

    const request = {
      personal,
      configuration: getConfiguration(state),
      meta,
    };

    dispatch(requestConfiguration());

    let response: OrderResponse;
    try {
      const { json } = await fetchData({
        endpoint,
        method: 'POST',
        body: request,
        uri: '',
        language,
      });
      response = json;
    } catch (error) {
      // If we have a FetchError, use meta.response.error
      const message = (error.meta && error.meta.response && error.meta.response.error)
            || error.message;

      // Convert error to JSON object
      dispatch(failConfiguration({
        code: error.status,
        message,
      }));
      throw error;
    }

    dispatch(successConfiguration(response));

    return response;
  }
);
